import { render } from "./ckeditorModal.vue?vue&type=template&id=3ed61ab7&scoped=true"
import script from "./ckeditorModal.vue?vue&type=script&lang=js"
export * from "./ckeditorModal.vue?vue&type=script&lang=js"

import "./ckeditorModal.vue?vue&type=style&index=0&id=3ed61ab7&lang=css"
import "./ckeditorModal.vue?vue&type=style&index=1&id=3ed61ab7&scoped=true&lang=css"

import exportComponent from "D:\\work\\sckj\\wwei\\ww-vue\\wwei_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ed61ab7"]])

export default __exports__